export enum PAYMENT_TARIFF {
  DEFAULT = 'default',
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
  V4 = 'v4',
  V5 = 'v5',
  V6 = 'v6',
  V7 = 'v7',
  V8 = 'v8',
  V9 = 'v9',
  V10 = 'v10',
  V11 = 'v11',
  V12 = 'v12',
  V13 = 'v13',
  V14 = 'v14',
  V15 = 'v15',
  V16 = 'v16',
  V17 = 'v17',
  V18 = 'v18',
  V19 = 'v19',
  V20 = 'v20',
  V21 = 'v21',
  V22 = 'v22',
  V23 = 'v23',
  V24 = 'v24',
  V25 = 'v25',
  V26 = 'v26',
  V27 = 'v27',
  V28 = 'v28',

  V29 = 'v29',
  V30 = 'v30',

  V31 = 'v31',
  V32 = 'v32',
  
  V33 = 'v33',
  V34 = 'v34',

  V35 = 'v35',
  V36 = 'v36',

  V37 = 'v37',
  V38 = 'v38',

  V39 = 'v39',
  V40 = 'v40',

  V41 = 'v41',
  V42 = 'v42',

  V43 = 'v43',
  V44 = 'v44',

  V45 = 'v45',
  V46 = 'v46',

  V47 = 'v47',

  V48 = 'v48',

  V49 = 'v49',

  WINBACK_V1 = 'WINBACK_V1',

  /** Single-price paywall based on v41: one flat 1-day test subscription ($9.99), no tiers. */
  V001 = 'v001',

  /** Same as V001, but with the EUR product/id — always shows the € symbol. */
  V002 = 'v002',

  /** Same as V001, but with the GBP product/id — always shows the £ symbol. */
  V003 = 'v003',
}
